// バリエーションを切り替えた時に、税込価格を再計算
document.addEventListener('DOMContentLoaded', function () {
  const tax_rate = parseFloat(document.getElementById('tax_rate').getAttribute('data-title'));
  const priceElement = document.querySelector('.price__current'); // 価格表示要素を指定
  const comparePriceElement = document.querySelector('.price__was'); // 価格表示要素を指定
  const priceWrapperElement = document.querySelector('.price'); // 価格表示要素を指定

  // MutationObserverのコールバック関数
  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      if (mutation.type === 'childList') {

        // price の処理
        let currentPrice = priceElement.textContent.replace('¥', '').replace(',', '');
        currentPrice = parseInt(currentPrice, 10); // 数値に変換
        let newPrice = Math.round(currentPrice * tax_rate);

        // compare price の処理
        let newComparePrice = 0;
        if (comparePriceElement && comparePriceElement.textContent) {
          let comparePrice = comparePriceElement.textContent.replace('¥', '').replace(',', '');
          comparePrice = parseInt(comparePrice, 10); // 数値に変換
          if (!isNaN(comparePrice)) {
            newComparePrice = Math.round(comparePrice * tax_rate);
          }
        }
        
        // 一時停止
        observer.disconnect();
        
        // 新しい価格を表示
        priceElement.innerHTML = '¥' + newPrice.toLocaleString() + ' <span class="zeikomi">（税込）</span>'; // カンマ区切りのフォーマットで表示
        
        // comparePriceElement が存在し、newComparePrice が有効な値である場合のみ更新
        if (comparePriceElement && newComparePrice > 0) {
          comparePriceElement.innerHTML = '¥' + newComparePrice.toLocaleString(); // カンマ区切りのフォーマットで表示
        }

        // sale price クラスの Toggle
        if (newComparePrice > newPrice && newComparePrice > 0) {
          priceWrapperElement.classList.add('price--on-sale');
        } else {
          priceWrapperElement.classList.remove('price--on-sale');
        }

        // 再度監視開始
        observer.observe(priceElement, config);
      }
    });
  });

  // 監視の設定
  const config = { childList: true, subtree: false }; // 子要素の変更を監視
  // 監視開始
  observer.observe(priceElement, config);

});